<template>
    <v-container >
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <h1 class="mb-3 heading deep-purple--text text--accent-3">Transporta līdzekļi</h1>
                </v-flex>

                <v-spacer></v-spacer>

                <v-flex xs10 sm4 >
                    <v-text-field
                            @input="searchVehicles"
                            v-model="search"
                            append-icon="search"
                            label="Meklēt"
                            single-line
                            color="deep-purple accent-3"
                            class="mb-2"
                    ></v-text-field>
                </v-flex>
                <v-flex v-if="!showForm" xs2 sm1 class="pt-2 text-xs-right">
                    <v-tooltip top>
                        <v-btn  @click="showAddVehicleForm" small outline fab color="deep-purple" slot="activator">
                            <v-icon >add</v-icon>
                        </v-btn>
                        <span>Pievienot transporta līdzekli</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-if="showForm" xs2 sm1 class="pt-2 text-xs-right">
                        <v-btn  @click="hideAddVehicleForm" small outline fab color="deep-orange lighten-1" slot="activator">
                            <v-icon >block</v-icon>
                        </v-btn>

                </v-flex>

            </v-layout>

        <add-vehicle v-if="showForm"></add-vehicle>

        <template v-if="vehicles">
            <v-card flat v-for="vehicle in vehicles.data" :key="vehicle.regNr">
                <v-layout row wrap class="pa-3 mb-1">
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Reģ. Nr</div>
                        <div>{{vehicle.regNr}}</div>
                    </v-flex>
                    <v-flex xs6 md3>
                        <div class="caption grey--text">Marka</div>
                        <div>{{vehicle.manufacturer}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Modelis</div>
                        <div>{{vehicle.model}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Ražošanas gads</div>
                        <div>{{vehicle.year}}</div>
                    </v-flex>
                    <v-flex xs6 md2>
                        <div class="caption grey--text">Tips</div>
                        <div>{{vehicle.type}}</div>
                    </v-flex>
                    <v-flex xx12 sm4 md1>
                        <v-layout row wrap>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon to="" flat small slot="activator">
                                        <v-icon color="grey">open_in_new</v-icon>
                                    </v-btn>
                                    <span>Skatīt transporta līdzekli</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs6>
                                <v-tooltip top>
                                    <v-btn icon @click="deleteVehicle(vehicle.id)" flat small slot="activator">
                                        <v-icon color="grey">delete</v-icon>
                                    </v-btn>
                                    <span>Dzēst transporta līdzekli</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>

            <v-layout row>
                <v-flex v-if="vehicles.meta.last_page > 1" sm6  offset-sm4>
                    <v-pagination
                            v-model="vehicles.meta.current_page"
                            :length="vehicles.meta.last_page"
                            :total-visible="5"
                            color="deep-purple accent-3"
                            @input="onPageChange"
                    ></v-pagination>
                </v-flex>
            </v-layout>
        </template>

        <v-snackbar
                v-model="snackbar"
                :color="color"
                :timeout="timeout"
                auto-height
                right
        >
            {{ text }}
            <v-btn dark
                   flat
                   @click="snackbar = false"
            >X</v-btn>
        </v-snackbar>

    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import AddVehicle from "../components/AddVehicle.vue";

    export default {
        name: "Vehicles",
        components: {AddVehicle},
        data: () => ({
            snackbar: false,
            color: '',
            timeout: 2000,
            text: ''
        }),
        mounted() {
            this.$store.dispatch('hideAddVehicleForm')
            this.$store.dispatch('resetSearch')
            this.$store.dispatch('getVehicles')
        },
        computed: {
            ...mapGetters({
                vehicles: 'vehicles',
                search: 'search',
                showForm: 'showAddVehicleForm'
            })
        },
        methods: {
            searchVehicles(value){
                this.$store.dispatch('changeSearch', value)
                this.$store.dispatch('getVehicles')
            },
            onPageChange() {
                this.$store.dispatch('getVehicles', this.vehicles.meta.current_page);
            },
            showAddVehicleForm(){
                this.$store.dispatch('showAddVehicleForm')
            },
            hideAddVehicleForm(){
                this.$store.dispatch('hideAddVehicleForm')
            },
            deleteVehicle(vehicleId){
                if(confirm('Vai esi drošs?')){
                    this.$Progress.start()
                    this.$store.dispatch('deleteVehicle', vehicleId)
                    this.snackbar = true
                    this.color = 'red'
                    this.text = 'Transporta līdzeklis dzēsts'
                }
            }



        }
    }
</script>

<style scoped>

</style>